/*
 * @Author: Teemo Ding
 * @Date: 2021-05-27 11:43:45
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-20 17:28:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelCollection/Components/Products/index.tsx
 */
import { Button } from '@/src/components/Antd';
import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import DroppableTable from '@/src/components/DroppableTable/DroppableTable';
import { Divider } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import {
  currentPrimaryLanguage,
  updateSelectedLanguage,
} from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import SectionHOC from 'src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC';
import { productsColumns } from '../../SalesChannelCollectionConfig';
import CopyModal from '../CopyModal';

import Table from '@/src/components/Antd/Table/SizeFittingTable';
import { InfoCircleOutlined } from '@ant-design/icons';
import CollectionProductsSelection from 'src/constrains/ProductsSelection/CollectionProductsSelection';
import { SectionContent } from 'src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { EnumCollapseId } from '../../common';
import { getCollapse, onCollapseChange } from '../../slice/edit';

import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import css from './css.less';

const Products = ({
  products,
  onChange,
  salesChannelUuid,
  collectionList,
  setModalTitle,
  setModalContent,
  setShowModal,
  salesChannelProductUuids,
  isPrimary,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [rowSelection, setRowSelections] = React.useState([]);
  const [visible, setVisible] = React.useState(false);
  const primaryLanguage = useSelector(currentPrimaryLanguage());
  const d = useDispatch();
  const row = {
    selectedRowKeys: rowSelection,
    onChange: setRowSelections,
  };
  const onCancel = () => {
    setVisible(false);
  };
  const onOpen = () => {
    setVisible(true);
  };
  const onOk = (products = []) => {
    const _pWithDraggableId = products.map((i) => {
      const { uuid } = i;
      return { ...i, draggableId: uuid };
    });
    onChange(_pWithDraggableId);
  };

  const deleteFun = (deleteUuids) => {
    const leftoverProducts = products.filter(
      (o) => !deleteUuids.includes(o.uuid),
    );
    onChange(leftoverProducts);
  };

  const handleToPrimaryLanguage = () => {
    d(
      updateSelectedLanguage({
        salesChannelUuid: salesChannelUuid,
        selectedLanguage: primaryLanguage,
      }),
    );
  };

  const buttonMenu = [
    //Bulk Edit
    {
      key: 1,
      value: getI18n('productCollection.index.copytocollection'),
      function: () => {
        if (rowSelection.length > 0) {
          setModalTitle(
            getI18n('productCollection.index.copyProductstoCollection'),
          );
          setShowModal(true);
          setModalContent(
            <CopyModal
              collectionList={collectionList}
              setShowModal={setShowModal}
              salesChannelProductUuids={rowSelection}
            />,
          );
        }
      },
    },
    {
      key: 2,
      value: (
        <WarningPopReminder
          title={getI18n('productCollection.index.removeProduct')}
          content={getI18n('productCollection.index.removeProductContent')}
          onOkText={getI18n('general.remove')}
          onOk={() => {
            deleteFun(rowSelection);
          }}>
          <a href='#' className={css.errorText}>
            {getI18n('general.remove')}
          </a>
        </WarningPopReminder>
      ),
    },
  ];
  return (
    <SectionContent>
      {visible && (
        <CollectionProductsSelection
          visible={visible}
          onCancel={onCancel}
          onOk={onOk}
          selectedItems={products}
          salesChannelUuid={salesChannelUuid}
        />
      )}
      {isPrimary && !disabled ? (
        <div className={css.tableHeader}>
          <BulkEditor
            bulkEditItemClassName={css.tableHeaderDrop}
            buttonMenu={buttonMenu}
            dataSource={products || []}
            hideSelectAll
            selectedRowKeys={rowSelection} //mappedSelectedKeys}
            // allSelected={mappedSelectedKeys}
          />
          <Button type='primary' className={css.selectionBtn} onClick={onOpen}>
            {getI18n('general.selectProduct')}
          </Button>
        </div>
      ) : (
        ''
      )}
      {isPrimary && !disabled ? (
        <DroppableTable
          rowSelection={row}
          rowKey={'uuid'}
          dataSource={products || []}
          columns={productsColumns(deleteFun, isPrimary && !disabled, {
            getI18n,
          })}
          id='StockProductSelection'
          pagination={false}
          onTableChange={(products) => onChange(products)}
          // rowDeleteFunc={deleteProduct}
        />
      ) : (
        <Table
          rowKey={'uuid'}
          dataSource={products || []}
          pagination={false}
          columns={productsColumns(deleteFun, isPrimary && !disabled, {
            getI18n,
          })}
          id='StockProductSelection'
        />
      )}
      {!isPrimary && !disabled && <Divider />}
      {!isPrimary && !disabled && (
        <div className={css.setPrimary}>
          <InfoCircleOutlined />{' '}
          {getI18n('productCollection.index.switchtoprimarylanguage')}
          <span onClick={handleToPrimaryLanguage} className={css.tagsRightPart}>
            {' '}
            {primaryLanguage} ({getI18n('general.primary')}){' '}
          </span>{' '}
          {getI18n('productCollection.index.toeditthissection')}
        </div>
      )}
    </SectionContent>
  );
};
export default SectionHOC(Products, {
  id: EnumCollapseId.Products,
  title: getI18nFromGeneral('general.sider.products'),
  getCollapse,
  onCollapseChange,
});
